import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/services/v1/authentication.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(
    private router: Router,
    private authService: AuthenticationService
  ) { }

  ngOnInit() {
    this.deleteLocalStorage();
    this.router.navigateByUrl('/login');
  }

  deleteLocalStorage() {
    localStorage.removeItem('o__token');
    localStorage.removeItem('o__id');
    localStorage.removeItem('orders');
    this.authService.logout();
  }
}
